<div class="check-lists__panels">
  <div class="check-lists__panel">
    <div class="check-lists__panel-header">Вопросы ({{ (questions$ | async)?.length }})</div>

    <app-check-lists-filters
      #filters
      [categories]="categories$ | async"
      (changedCategory)="handleChangeCategory($event)"
      (applied)="handleApply($event)"
      (reset)="handleReset($event)"
      (created)="handleCreate($event)"
    >
    </app-check-lists-filters>

    <app-select-all
      label="Удалить"
      class="check-lists__selector"
      [formControl]="selectAllQuestions"
      (selectedAll)="handleSelectAll($event, questionGroups)"
      (deleted)="handleDeleteQuestions(questionGroups, filters.value)"
    >
    </app-select-all>

    <div class="check-lists-questions" [@listAnimation]="$safeNavigationMigration(questionGroups?.length)">
      <ng-container *ngFor="let group of questionGroups" [formGroup]="group">
        <check-lists-question
          formControlName="selected"
          class="check-lists__question check-lists__question--move"
          [canMove]="selectedChecklist && !isIncluded(group)"
          [question]="group.get('question').value"
          (moved)="handleMove($event)"
        >
        </check-lists-question>
      </ng-container>
    </div>

    <ui-pagination *ngIf="paginationConfig.collectionSize" class="tbl__pagination" [pagination]="paginationConfig" (changedPage)="handlePageChange($event)"> </ui-pagination>
  </div>

  <div class="check-lists__panel">
    <div class="check-lists__panel-header">
      Подобранные вопросы ( 0 /
      {{ (checklist$ | async)?.questions?.length || 0 }} )
    </div>

    <form [formGroup]="checklistForm">
      <div class="check-lists__dashboard">
        <app-select
          formControlName="checklist"
          class="check-lists__control check-lists__section"
          [items]="checklists$ | async | func: filterRoot"
          [defaultText]="'Выбрать тип заявки'"
          [nullChoice]="true"
          (callback)="handleChangeChecklist($event)"
          [textKey]="'name'"
          [name]="'CheckListCategory'"
        >
        </app-select>

        <app-check-lists-local
          *ngIf="isLocalChecklist"
          class="check-lists__local"
          [hdTicketTypes]="hdTicketTypes$ | async"
          [checklists]="checklists$ | async | func: filterLocal"
          (created)="handleCreateChecklist($event)"
          (selected)="handleChangeChecklist($event)"
          (changed)="handleChangeTicketType()"
        >
        </app-check-lists-local>
        <app-check-lists-global-problem
          #globalProblemComponent
          *ngIf="isProbleChecklist"
          class="check-lists__global-problem"
          [gpSubtypes]="checkListsService.gpSubtypes$ | async"
          [checklists]="checklists$ | async | func: filterProblem"
          (created)="handleCreateChecklist($event)"
          (selected)="handleChangeChecklist($event)"
          (changed)="handleChangeTicketType()"
        >
        </app-check-lists-global-problem>
      </div>

      <div class="check-lists__sub-header">
        <app-select-all
          label="Удалить"
          class="check-lists__selector"
          [formControl]="selectAllChecklist"
          (selectedAll)="handleSelectAll($event, checklistQuestionGroups)"
          (deleted)="handleDeleteChecklist(checklistQuestionGroups)"
        >
        </app-select-all>
        <app-switch *ngIf="selectedChecklist" [formControl]="checklistEnabler" (changed)="handleChangeEnabler()"> Включение Чек-Листа </app-switch>
      </div>

      <app-message *ngIf="!selectedChecklist" [type]="'error'" [size]="'small'">
        <div message-content>
          Невозможно переместить объекты до выбора типа заявки.<br />
          Выберите один из вариантов для возможности подбора вопросов
        </div>
      </app-message>

      <div class="check-lists__questions check-lists__questions--checklist" [@listAnimation]="$safeNavigationMigration(checklistQuestionGroups?.length)">
        <div *ngFor="let group of checklistQuestionGroups" [formGroup]="group" class="check-lists__question">
          <check-lists-question
            formControlName="selected"
            (sorted)="handleSort($event, group)"
            (required)="handleRequired($event, group)"
            [isChecklist]="true"
            [question]="group.get('question').value"
          >
          </check-lists-question>
        </div>
      </div>
      <div class="checklist-actions">
        <button
          class="button checklist-actions__save-btn check-lists-list__button"
          (click)="handleSaveChecklist()"
          [disabled]="(!hasChanges && !hasEnablerChanges) || checklistForm.invalid"
        >
          Сохранить
        </button>
        <a class="link link--dotted-blue-dark checklist-actions__link" [class.checklist-actions__link--disabled]="checklistForm.invalid" (click)="handleChecklistCancel()">
          Отменить
        </a>
      </div>
    </form>
  </div>
</div>
